module.exports = __webpack_public_path__ + "static/media/Muli-Light.923c071b.ttf";